import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import axios from 'axios';
import store from './store';
import AppWrapper from './AppWrapper';
import reportWebVitals from './reportWebVitals';

if (process.env.NODE_ENV === 'development') {
    axios.interceptors.request.use((config) => {
        if (config.url && config.url.startsWith('http://localhost/Counter-Backend')) {
            config.url = config.url.replace('http://localhost/Counter-Backend', '/Counter-Backend');
        }
        return config;
    });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <Provider store={store}>
            <HashRouter>
                <AppWrapper></AppWrapper>
            </HashRouter>
        </Provider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
